import { computed } from 'vue';

export function useChannelIcon(inbox) {
  const channelTypeIconMap = {
    'Channel::Api': 'i-woot-api',
    // [omnireply-patch] Email: lucide envelope — the remix mail-line looked off,
    // and lucide matches the Console /inboxes MailGlyph (which is lucide-style).
    'Channel::Email': 'i-lucide-mail',
    // [omnireply-patch] FB page inbox: show the Facebook "f" mark instead of the
    // Messenger bubble. The channel IS a Page's Messenger inbox, so the stock
    // icon is technically correct, but the brand wants FB identity in the list.
    'Channel::FacebookPage': 'i-ri-facebook-fill',
    'Channel::Line': 'i-woot-line',
    'Channel::Sms': 'i-woot-sms',
    'Channel::Telegram': 'i-woot-telegram',
    'Channel::TwilioSms': 'i-woot-sms',
    'Channel::TwitterProfile': 'i-woot-x',
    // [omnireply-patch] 官網(website widget): globe emphasises「網站」(was i-woot-website).
    'Channel::WebWidget': 'i-ri-global-line',
    'Channel::Whatsapp': 'i-woot-whatsapp',
    'Channel::Instagram': 'i-woot-instagram',
    'Channel::Tiktok': 'i-woot-tiktok',
    'Channel::Voice': 'i-woot-voice',
  };

  // [omnireply-patch] Do NOT swap the email icon for a provider logo
  // (Outlook / Gmail). The Console /inboxes list paints ONE amber envelope
  // (MailGlyph) for every email inbox regardless of provider, and owner wants
  // the 對話中心 sidebar 對話管道 list to match. Upstream's providerIconMap
  // ({ microsoft: 'i-woot-outlook', google: 'i-woot-gmail' }) and its
  // `Channel::Email` + inbox.provider override are intentionally dropped, so a
  // Microsoft/Google mailbox renders the same i-lucide-mail envelope as a
  // generic IMAP mailbox — and picks up ChannelLeaf's amber #B45309 tint, since
  // i-lucide-mail is a currentColor mask (the full-colour i-woot-outlook logo
  // never took the tint, which is why prior email-icon patches "did not show"
  // on Microsoft-connected inboxes). Upstream restore: re-add providerIconMap +
  // the `if (type === 'Channel::Email' && inboxDetails.provider) { … }` block.
  const channelIcon = computed(() => {
    const inboxDetails = inbox.value || inbox;
    const type = inboxDetails.channel_type;
    let icon = channelTypeIconMap[type];

    // Special case for Twilio whatsapp
    if (type === 'Channel::TwilioSms' && inboxDetails.medium === 'whatsapp') {
      icon = 'i-woot-whatsapp';
    }

    return icon ?? 'i-ri-global-fill';
  });

  return channelIcon;
}
